module.exports = __webpack_public_path__ + "src/assets/img/smoke_two.5b019901.svg";